import { StateCreator } from 'zustand';

import { User } from '../models';
import { CombinedSlices } from '.';

export interface UserSlice {
  user: User | null;
  setUser: (c: User | null) => void;
}

export const createUserSlice: StateCreator<
  CombinedSlices,
  [],
  [],
  UserSlice
> = (set) => ({
  user: null,
  setUser: (u: User | null) => set((_state) => ({ user: u }))
});
